var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowFatDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5302 13.2806L12.5302 22.2806C12.4606 22.3504 12.3779 22.4057 12.2868 22.4434C12.1958 22.4812 12.0982 22.5006 11.9996 22.5006C11.9011 22.5006 11.8035 22.4812 11.7124 22.4434C11.6214 22.4057 11.5386 22.3504 11.469 22.2806L2.46899 13.2806C2.36398 13.1757 2.29245 13.042 2.26347 12.8965C2.23448 12.7509 2.24933 12.6 2.30615 12.4629C2.36296 12.3258 2.45918 12.2086 2.58263 12.1262C2.70607 12.0438 2.85119 11.9999 2.99961 12H6.74961V4.5C6.74961 4.10218 6.90765 3.72064 7.18895 3.43934C7.47026 3.15804 7.85179 3 8.24961 3H15.7496C16.1474 3 16.529 3.15804 16.8103 3.43934C17.0916 3.72064 17.2496 4.10218 17.2496 4.5V12H20.9996C21.148 11.9999 21.2932 12.0438 21.4166 12.1262C21.54 12.2086 21.6363 12.3258 21.6931 12.4629C21.7499 12.6 21.7648 12.7509 21.7358 12.8965C21.7068 13.042 21.6353 13.1757 21.5302 13.2806Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFatDown);
export default __webpack_public_path__ + "static/media/ArrowFatDown.5e95e14a0054e2436ec5e19af2bf6298.svg";
export { ForwardRef as ReactComponent };